import {
  type ApiTradeV1TradeCompaniesEmployeesRetrieveEmployeeDepartment,
  type TradeCompanyEmployeeDTO,
  useApiTradeV1TradeCompaniesEmployeesRetrieve,
} from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<TradeCompanyEmployeeDTO>, 'options'> & {
  tradeCompanyId: number;
  department?: ApiTradeV1TradeCompaniesEmployeesRetrieveEmployeeDepartment;
  disableOptionsWithoutCommSettings?: boolean;
};

export const TradeCompanyEmployeeAutocompleteField = ({
  tradeCompanyId,
  department,
  disableOptionsWithoutCommSettings = false,
  ...rest
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data, isLoading } = useApiTradeV1TradeCompaniesEmployeesRetrieve(
    tradeCompanyId,
    {
      employee_department: department,
    },
    {
      query: {
        enabled: isOpen,
      },
    }
  );

  return (
    <AutocompleteField<TradeCompanyEmployeeDTO>
      options={data?.results || []}
      valueField="id"
      getOptionLabel={({ full_name }) => full_name}
      loading={isLoading}
      onOpen={() => {
        setIsOpen(true);
      }}
      getOptionDisabled={(option) => {
        if (disableOptionsWithoutCommSettings) {
          const isReachableViaWhatsapp = option.whatsapp_enabled && option.phone_number;
          const isReachableViaEmail = option.email_enabled && option.email;
          return !(isReachableViaWhatsapp || isReachableViaEmail);
        }
        return false;
      }}
      {...rest}
    />
  );
};
